import { render, staticRenderFns } from "./modal-tutorial.vue?vue&type=template&id=6527da1c&"
import script from "./modal-tutorial.vue?vue&type=script&lang=js&"
export * from "./modal-tutorial.vue?vue&type=script&lang=js&"
import style0 from "./modal-tutorial.vue?vue&type=style&index=0&id=6527da1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports